import { render, staticRenderFns } from "./AccountInvestigationOnboarding.vue?vue&type=template&id=202c9028&scoped=true&"
import script from "./AccountInvestigationOnboarding.vue?vue&type=script&lang=js&"
export * from "./AccountInvestigationOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./AccountInvestigationOnboarding.vue?vue&type=style&index=0&id=202c9028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202c9028",
  null
  
)

export default component.exports